/* template */
<template><div :class="({      'soldout-activity' :isActivityOut    })" class="header-soldOut-icon"><div :class="({          'isEn':isEn        })" class="header-soldOut-text">{{text}}</div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m3eb8d8a0"}'>
@import "../../../lib/stylus/variable.styl"
.header-soldOut-icon
    width 163rpx
    height 163rpx
    background-image: url("https://ut-static.udache.com/webx/fe-agility-wyc/bhKlPS1ptWji7GCBHlfCe.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    font-weight: $fw-semi-bold;
    font-size: 35rpx;
    color: #FFFFFF;
    text-align: center;
    line-height: 44rpx;
    &.soldout-activity
      width 163rpx
      height 163rpx
      background-image: url("https://ut-static.udache.com/webx/fe-agility-wyc/bhKlPS1ptWji7GCBHlfCe.png")
      background-repeat: no-repeat
      background-size: 100% 100%
      .header-soldOut-text
        top:90rpx
    .header-soldOut-text
      width 100%
      height 100%
      box-sizing border-box
      opacity 0.9
      transform rotate(-30deg)
      display flex
      align-items center
      justify-content center
      &.isEn
        font-size 25rpx
        line-height: 30rpx;
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
import { EnumSoldOutType, EnumLang } from '../../../lib/webx/defines/enums.js'
import { GlobalEnv } from '../../../lib/webx/global_env/index.js'
createComponent({
  properties: {
    soldOutType: {
      type: String,
    },
  },
  computed: {
    isActivityOut() {
      return this.soldOutType === EnumSoldOutType.Activity
    },
    text() {
      return this.isActivityOut ? this.$t('goodsDetail.soldOut') : this.$t('goodsDetail.thisRoundSoldOut')
    },
    isEn() {
      return GlobalEnv.lang === EnumLang['en-US']
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "soldout-logo3eb8d8a0",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
